export class TraceabilityDto {
  constructor(
    public linkedToId: number,
    public status: string,
    public comment?: string,
    public signatureData?: string,
  ) {}
}
